import { inject, InjectionToken } from '@angular/core';

export interface IAuthConfig {
  show2faPrompt: boolean;
}

export const AUTH_CONFIG = new InjectionToken<Partial<IAuthConfig>>(
  'AUTH_CONFIG',
);

export const provideAuthConfig = (config: Partial<IAuthConfig>) => ({
  provide: AUTH_CONFIG,
  useValue: config,
});

export const injectAuthConfig = () => {
  const config = inject(AUTH_CONFIG, { optional: true });
  const defaultConfig: IAuthConfig = {
    show2faPrompt: false,
  };

  return {
    ...defaultConfig,
    ...config,
  };
};
